export default __webpack_public_path__ + "static/media/ControlFrameImg.84232b1a.jpg";